import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdditionalAnalysisRequestComponent } from '../additional-analysis-request/additional-analysis-request.component';
import { AnalysisRequestComponent } from '../analysis-request/analysis-request.component';

@Component({
  selector: 'app-analysis-request-review',
  templateUrl: './analysis-request-review.component.html',
  styleUrls: ['./analysis-request-review.component.scss']
})
export class AnalysisRequestReviewComponent implements OnInit {
  isAnalysisReqReviewConsent = false;

  constructor(
    private readonly dialog: MatDialog,
    public dialogRef: MatDialogRef<AnalysisRequestReviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
  ) {

     console.log(
  "Package:",
  JSON.stringify(data));
  }

  ngOnInit(): void {
     if (this.data?.isAnalysisReqReviewConsent) {
    this.isAnalysisReqReviewConsent = this.data.isAnalysisReqReviewConsent;
 
   
  }
  }

  get selectedDataCount(): number {
    if (!this.data.selectedPackages) return 0;
     
    return this.data.selectedPackages.reduce((count, pkg) => {
      return count + (pkg.templateNames ? pkg.templateNames.length : 0);
    }, 0);
    
  }

  get hasSelectedAnalyses(): boolean {
    return this.selectedDataCount > 0;
  }

  // Remove selected template
  removeTemplate(pkg: any, index: number): void {
    if (!pkg.templateNames || !pkg.templateIds) return;
    
    // Remove the template
    pkg.templateNames.splice(index, 1);
    pkg.templateIds.splice(index, 1);
    
    // If no templates left in this package, remove the whole package
    if (pkg.templateNames.length === 0) {
      const pkgIndex = this.data.selectedPackages.indexOf(pkg);
      if (pkgIndex > -1) {
        this.data.selectedPackages.splice(pkgIndex, 1);
      }
    }
    
    // Uncheck consent when no analyses remain
    if (!this.hasSelectedAnalyses) {
      this.isAnalysisReqReviewConsent = false;
    }
  }

  onBack(): void {
    // Return current selections so the previous dialog can restore state
    this.dialogRef.close({
      action: 'back',
      selectedPackages: this.data.selectedPackages,
      isAnalysisReqReviewConsent: this.isAnalysisReqReviewConsent
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (!this.isAnalysisReqReviewConsent || !this.hasSelectedAnalyses) {
      
      return;
    }
    
    const payload = {
      patientId: this.data.patientId,
      selectedPackages: this.data.selectedPackages.map(pkg => ({
        packageId: pkg.packageId,
        templateIds: pkg.templateIds
      })),
      isAnalysisReqReviewConsent: this.isAnalysisReqReviewConsent,
    };

    this.dialogRef.close();

    const dialogRef = this.dialog.open(AdditionalAnalysisRequestComponent, {
      width: '600px',
      disableClose: true,
      autoFocus: false,
        data: {
  originalData: this.data,
  payload: payload
}
    });

    dialogRef.afterClosed().subscribe(result => {
    if (result === 'back') {
      // User clicked "Back" → reopen this Review dialog again
      const reviewRef = this.dialog.open(AnalysisRequestReviewComponent, {
        width: '630px',
        disableClose: true,
        autoFocus: false,
        data: {
          patientId: this.data.patientId,
          selectedPackages: this.data.selectedPackages,
          isAnalysisReqReviewConsent: this.isAnalysisReqReviewConsent
        }
      });

      reviewRef.afterClosed().subscribe(revResult => {
        if (revResult && revResult.action === 'back') {
          this.dialog.open(AnalysisRequestComponent, {
            width: '630px',
            disableClose: true,
            autoFocus: false,
            data: {
              patientId: this.data.patientId,
              selectedPackages: revResult.selectedPackages
            }
          });
        } else if (revResult) {
          // Bubble up any other close payload to whoever opened this Review
          this.dialogRef.close(revResult);
        }
      });

    } else {
      // Normal close
       this.dialogRef.close(payload);
    }
  });
  }
}